<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/Facilities/Keys">Facilities</b-breadcrumb-item>
            <b-breadcrumb-item to="/Facilities/Keys">Keys</b-breadcrumb-item>
            <b-breadcrumb-item :to="{name:'KeyDetails',params:{id:facilitiesKeyId,keyNumber:facilitiesKeyNumber}}">{{facilitiesKeyNumber}}</b-breadcrumb-item>
            <b-breadcrumb-item active>Edit Copy {{facilitiesKeyCopyNumber}}</b-breadcrumb-item>
        </b-breadcrumb>

        <form @submit.prevent="onSubmit()">
            <div class="card">
                <div class="bg-dark card-header text-white">Edit Copy {{facilitiesKeyCopyNumber}}</div>
                <div class="card-body">
                    <div class="pb-3">
                      <b>Key Type:</b> {{ facilitiesKeyTypeName }}
                    </div>
                    <div class="col-lg-4 col-sm-12 form-group">
                        <label for="facilitiesKeyCopyStatusId">Status</label>
                        <select :class="{'is-invalid': $v.facilitiesKeyCopyStatusId.$invalid && isValidating}"
                                class="form-control" v-model="facilitiesKeyCopyStatusId"
                                @change="clearValues()">
                            <option :value="null" disabled>--Select Status--</option>
                            <option :key="facilitiesKeyCopyStatus.id" :value="facilitiesKeyCopyStatus.id" v-for="facilitiesKeyCopyStatus in facilitiesKeyCopyStatusList">{{facilitiesKeyCopyStatus.name}}</option>
                        </select>
                        <span class="invalid-feedback" v-if="!$v.facilitiesKeyCopyStatusId.required && isValidating">Field is required</span>
                    </div>
                    
                    <div v-if="facilitiesKeyCopyStatusId === facilitiesKeyCopyStatuses.Issued" class="col-lg-4 col-sm-12 form-group">
                        <label for="statusForPersonId">Issue to</label>
                        <select :class="{'is-invalid': $v.statusForPersonId.$invalid && isValidating}"
                                class="form-control" v-model="statusForPersonId">
                            <option :value="null" disabled>--Select Person--</option>
                            <option :key="person.id" :value="person.id" v-for="person in people">{{person.name}}</option>
                        </select>
                        <span class="invalid-feedback" v-if="!$v.statusForPersonId.required && isValidating">Field is required</span>
                    </div>

                    <div v-if="facilitiesKeyCopyStatusId === facilitiesKeyCopyStatuses.Stored" class="col-lg-2 col-sm-8 form-group">
                        <label for="hookNumber">Hook Number</label>
                        <input :class="{'is-invalid': $v.hookNumber.$invalid && isValidating}"
                                class="form-control"
                                maxlength="3"
                                v-model="hookNumber"/>
                        <span class="invalid-feedback" v-if="!$v.hookNumber.required && isValidating">Field is required</span>
                    </div>
                </div>
                <div class="card-footer d-print-none text-right">
                    <button :disabled="isSubmitting" class="btn btn-primary" type="submit">Save</button>
                    <RouterLink :to="{name:'KeyDetails',params:{id:facilitiesKeyId,keyNumber:facilitiesKeyNumber}}" class="btn btn-danger">Back</RouterLink>
                </div>
            </div>
        </form>

    </div>
</template>

<script>
    import {ToastType} from "@/services/models/shared/ToastType";
    import {required, requiredIf} from "vuelidate/lib/validators";
    import FacilitiesKeysService from "@/services/FacilitiesKeysService";
    import PersonService from "@/services/PersonService";
    import { FacilitiesKeyCopyStatus } from "@/services/models/FacilitiesKey";

    export default {
        props: {
            id: {
              type: String,
              required: true
            },
            facilitiesKeyId: {
              type: String,
              required: true
            },
            facilitiesKeyNumber: {
              type: String,
              required: true
            },
            facilitiesKeyTypeName: {
              type: String,
              required: true
            },
            facilitiesKeyCopyNumber: {
              type: String,
              required: true
            }
        },
        data() {
            return {
                isSubmitting: false,
                isValidating: false,
                people: [],
                facilitiesKeyCopyStatuses: FacilitiesKeyCopyStatus,
                hookNumber: null,
                facilitiesKeyCopyStatusId: null,
                statusForPersonId: null
            }
        },
        computed: {
          facilitiesKeyCopyStatusList () {
              return (Object.keys(FacilitiesKeyCopyStatus)).map(val => {
                return {
                    id: FacilitiesKeyCopyStatus[val],
                    name: val.toString()
                }
            })
          }
        },
        methods: {
            /**
             * @description Updates a key copy and redirects if successful
             */
            onSubmit() {
                const vm = this;
                vm.isValidating = true;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                vm.isSubmitting = true;
                FacilitiesKeysService.updateFacilitiesKeyCopy(this.id, {
                  hookNumber: this.hookNumber, 
                  facilitiesKeyCopyStatusId: this.facilitiesKeyCopyStatusId,
                  updatedByPersonId: this.$store.getters.user.id,
                  statusForPersonId: this.statusForPersonId
                })
                    .then(() => {
                      vm.alert(ToastType.Success, "The key copy was successfully updated");

                      // Redirect to the key detail page
                      vm.$router.replace({name:'KeyDetails',params:{id:vm.facilitiesKeyId,keyNumber:vm.facilitiesKeyNumber}})
                    })
                    .catch((error) => {
                      vm.alert(ToastType.Danger, error.response.data)
                    })
                    .finally(() => {
                      vm.isValidating = false;
                      vm.isSubmitting = false;
                    })
            },

            clearValues () {
                this.hookNumber = null;
                this.statusForPersonId = null;
            }
        },
        created() {
            const vm = this;

            PersonService.getAllPeople()
                .then(response => {
                    vm.people = response
                }).catch((error) => {
                    vm.alert(ToastType.Danger, error.response.data)
                    // Redirect to the key detail page
                    vm.$router.replace({name:'KeyDetails',params:{id:vm.facilitiesKeyId,keyNumber:vm.facilitiesKeyNumber}})
                })
        },
        validations: {
            facilitiesKeyCopyStatusId: {
              required
            },
            hookNumber: {
              required: requiredIf(function (val) {
                return val.facilitiesKeyCopyStatusId === this.facilitiesKeyCopyStatuses.Stored
              })
            },
            statusForPersonId: {
              required: requiredIf(function (val) {
                return val.facilitiesKeyCopyStatusId === this.facilitiesKeyCopyStatuses.Issued
              })
            }
        }
    }
</script>
